import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-btn-feature-toggle',
  templateUrl: './btn-feature-toggle.component.html',
  styleUrls: ['./btn-feature-toggle.component.scss']
})
export class BtnFeatureToggleComponent implements OnInit {

  @Output() callOnClick: EventEmitter<string> = new EventEmitter();
  @Output() callOffClick: EventEmitter<string> = new EventEmitter();
  @Input() btnId: string;
  @Input() btnOnLabel: string;
  @Input() btnOffLabel: string;
  @Input() btnValue: string;
  @Input() btnDisabled: boolean;

  constructor() {
  }

  ngOnInit(): void {
  }

  onBtnClick(): void {
    this.callOnClick.emit();
  }

  offBtnClick(): void {
    this.callOffClick.emit();
  }

}